import { render, staticRenderFns } from "./qx-btn.vue?vue&type=template&id=5aa5a0d3"
import script from "./qx-btn.vue?vue&type=script&lang=js"
export * from "./qx-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports